import React from 'react';
import { Field } from 'formik';

import { BaseField, BaseFieldWrap } from './base';

const Textarea = (props) => <Field {...props} as="textarea" />;

export const TextareaField = React.forwardRef(({ before, afterField, after, id, label, name, text, ...rest }, ref) => {
  return (
    <BaseFieldWrap {...{ before, afterField, after, id, label, name, text }}>
      <InlineTextareaField ref={ref} name={name} {...rest} />
    </BaseFieldWrap>
  );
});

export const InlineTextareaField = React.forwardRef(({ name, as = Textarea, ...rest }, ref) => (
  <BaseField ref={ref} name={name} as={as} {...rest} />
));
